import { Component, OnInit } from '@angular/core';

/**
 * フッターコンポーネント
 * @export
 * @class FooterComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  /**
   * コンストラクタ
   * @memberof FooterComponent
   */
  constructor() { }

  /**
   * 初期処理
   * @memberof FooterComponent
   */
  ngOnInit(): void {
  }

}
